import * as React from "react";

function Close({ theme = "red" }) {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='icoClose'>
        <path
          d='M3 3L17 17'
          stroke={theme}
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M17 3L3 17'
          stroke={theme}
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </g>
    </svg>
  );
}

export default Close;
